const dateFormatter = new Intl.DateTimeFormat('da-DK', {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
})

const dateTimeFormatter = new Intl.DateTimeFormat('da-DK', {
  day: 'numeric',
  month: 'short',
  hour: '2-digit',
  minute: '2-digit',
})

export function formatDate(value: string): string {
  if (!value) return 'Ikke planlagt'
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return value
  return dateFormatter.format(date)
}

export function formatDateTime(value: string): string {
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return value
  return dateTimeFormatter.format(date)
}

export function formatPrice(amount: string, suffix = 'kr.'): string {
  if (!amount) return '—'
  return `${amount} ${suffix}`
}

/** Sorts ascending by planned date; cases without a date go last. */
export function byPlannedDate<T extends { plannedDate: string }>(a: T, b: T): number {
  if (!a.plannedDate) return 1
  if (!b.plannedDate) return -1
  return a.plannedDate.localeCompare(b.plannedDate)
}
